import { $api } from "../generated/client";

type UseGetReturnRequestAverageTimeParams = {
	shopId: string;
	fromTimestamp: number;
	toTimestamp: number;
};

export function useGetDailyStatusEvolutioSuspense({
	fromTimestamp,
	shopId,
	toTimestamp,
}: UseGetReturnRequestAverageTimeParams) {
	return $api.useSuspenseQuery(
		"get",
		"/shops/{shopId}/statistics/daily-evolution",
		{
			params: { query: { fromTimestamp, toTimestamp }, path: { shopId } },
		},
	);
}
